
import Dexie from "dexie"
import { ITodo, ITodoSchedule,INote, INoteFolder, IProjectDetails } from "../types/interfaces"
import ProjectHandler from "./handlers/ProjectHandler"
function SetDefaults() {
  const projectHandler = new ProjectHandler()
  new AppDatabase().projects.where({projectName:"None"}).delete()
  projectHandler.CreateProject({
    author:"Guest",deadline:new Date,projectName:"None"
  })
}
export default class AppDatabase extends Dexie{
  todos!: Dexie.Table<ITodo, number>
  schedules!: Dexie.Table<ITodoSchedule, number>
  notes!: Dexie.Table<INote, number>
  notesFolder!: Dexie.Table<INoteFolder, number>
  projects!:Dexie.Table<IProjectDetails,number>
  constructor() {
    super("AppDatabase")
    
    this.version(2).stores({
      todos: "++id,sortOrder,title,description,priority,status,project",
      schedules: "++id,title,description,scheduleDate,todosArr,project",
      notes: "++id,title,description,content,folder,project",
      notesFolder: "++id,title,colour,notes,project",
      projects:"++id,author,projectName,deadline"
    })
   
    
  }
}


SetDefaults()